<template>
  <div :style="divStyle">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Tabs>
      <TabPane label="profile注册历史" name="list" icon="ios-list">
        <Table
          ref="selectionTable"
          :max-height="height"
          :data="showData"
          :columns="showColumns"
          stripe
          border
        >
          <template slot-scope="{ row, index }" slot="download">
            <Button type="primary" shape="circle" @click="downProfile(row, index, $event)">下载配置文件</Button>
          </template>
        </Table>
      </TabPane>
      <TabPane label="profile注册" name="tree" icon="ios-git-merge">
        <Input v-model="currentProfile" rows="19" type="textarea" placeholder="请键入配置文件内容" />
        <div style="margin-top:10px">
          <Button @click="formatJson" type="primary">格式化</Button>
          <Button @click="commitRegiste" type="primary" style="margin-left:10px">提交注册</Button>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  name: "registe_profile",
  computed: {
    divStyle() {
      var style = {};
      if(this.$parent.$refs.mainContent){
          style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      }else{
          style.width = window.innerWidth - 279 + "px";
      }
      //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    }
  },

  mounted() {
    this.showPage();
  },
  data() {
    return {
      currentProfile: "",
      isSpinShow: false,
      height: window.innerHeight,
      showData: [],
      showColumns: [
        {
          title: "变更日期",
          key: "time"
        },
        {
          title: "下载配置文件",
          slot: "download",
          align: "center"
        }
      ]
    };
  },
  methods: {
    formatJson() {
      let msg = "";
      try {
        msg = JSON.parse(this.currentProfile);
      } catch (err) {
        this.$Notice.info({
          title: "提示",
          desc: "JSON格式不符合规范请检查后重新校验"
        });
        return;
      }

      var rep = "~";
      var jsonStr = JSON.stringify(msg, null, rep);
      var str = "";
      for (var i = 0; i < jsonStr.length; i++) {
        var text2 = jsonStr.charAt(i);
        if (i > 1) {
          var text = jsonStr.charAt(i - 1);
          if (rep != text && rep == text2) {
            // str += "\n"
          }
        }
        str += text2;
      }
      jsonStr = "";
      for (var i = 0; i < str.length; i++) {
        var text = str.charAt(i);
        if (rep == text) jsonStr += "  ";
        else {
          jsonStr += text;
        }
        if (i == str.length - 2) {
        }
        // jsonStr += "\n"
      }
      this.currentProfile = jsonStr;
    },
    downProfile(row, index, event) {
      var FileSaver = require("file-saver");
      var content = JSON.stringify(row.content);
      var blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, row.time + ".json");
    },
    commitRegiste() {
      let msg = "";
      try {
        msg = JSON.parse(this.currentProfile);
      } catch (err) {
        this.$Notice.info({
          title: "提示",
          desc: "JSON格式不符合规范请检查后重新校验"
        });
        return;
      }

      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/registProfile",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          profile: that.currentProfile
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.$Notice.success({
            title: "提示",
            desc: "注册成功"
          });
          that.showPage();
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url: "/api/getProfileAndBackupArray",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.backup;
		  that.currentProfile = JSON.stringify(data.body.profile);
		  that.formatJson();
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    }
  }
};
</script>
<style>
.ivu-tree {
  left: 30%;
}

.ivu-tree ul {
  /* list-style: none; */
  margin: 5px;
  padding: 0;
  font-size: 16px;
}
</style>